import { render, staticRenderFns } from "./Detailhipmi.vue?vue&type=template&id=b14c21de"
import script from "./Detailhipmi.vue?vue&type=script&lang=js"
export * from "./Detailhipmi.vue?vue&type=script&lang=js"
import style0 from "./Detailhipmi.vue?vue&type=style&index=0&id=b14c21de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports